import React from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';
import { Subscribe } from 'unstated';
//
import AppState from 'state';
//
const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? { className: 'active' } : null;
};
//
const Client = ({ path, title }) => (
  <Subscribe to={[AppState]}>
    {(appState) => (
      <ClientWrap>
        <Link
          title={title}
          to={path}
          getProps={isPartiallyActive}
          onClick={() => appState.closeHeader()}
        >
          {title}
        </Link>
      </ClientWrap>
    )}
  </Subscribe>
);
//
export default ({
  clients,
  closeNav,
  fallBackHomepage,
  id,
  path,
  title,
  type,
}) => {
  if (type === 'category') {
    return (
      <Subscribe to={[AppState]}>
        {(appState) => (
          <Wrap
            active={appState.state.navState === id}
            allowActive={
              !appState.state.navState || appState.state.navState === id
            }
          >
            <Link
              title={title}
              to={`${path}/`}
              getProps={isPartiallyActive}
              onClick={(e) => {
                fallBackHomepage && e.preventDefault();
                appState.setNavState(id);
              }}
            >
              {title}
            </Link>

            {clients && clients.length > 0 && (
              <Clients>
                {clients.map((client) => (
                  <Client key={client.id} {...client} closeNav={closeNav} />
                ))}
              </Clients>
            )}
          </Wrap>
        )}
      </Subscribe>
    );
  }

  return (
    <Subscribe to={[AppState]}>
      {(appState) => (
        <Wrap>
          <Link
            title={title}
            to={path}
            getProps={isPartiallyActive}
            onClick={() => appState.setNavState(id)}
          >
            {title}
          </Link>
        </Wrap>
      )}
    </Subscribe>
  );
};
//
const Wrap = styled.li`
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  margin: 0;
  padding: 0;

  > a {
    display: block;
    padding: 0.5rem 0;
    text-transform: uppercase;
    width: 100%;

    & + ul {
      display: ${({ active }) => (active ? 'block' : 'none')};
    }

    &.active {
      font-weight: 700;

      & + ul {
        ${({ allowActive }) => allowActive && 'display: block;'};
      }
    }
  }
`;

const Clients = styled.ul``;

const ClientWrap = styled.li`
  margin: 0 0 0.5rem;

  a {
    display: block;

    &.active {
      font-weight: 700;
    }
  }
`;
